import { render } from "./SimpleSlider.vue?vue&type=template&id=48206d25"
import script from "./SimpleSlider.vue?vue&type=script&lang=js"
export * from "./SimpleSlider.vue?vue&type=script&lang=js"

import "./SimpleSlider.vue?vue&type=style&index=0&id=48206d25&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__